import { IApiMessageDto, IApiSubMessageDto } from '@/services/swagger/easourcing/models';
import { MessageWithTime } from '@/utils/message-timer';
import { Copy } from 'lucide-react';
import { PropsWithChildren, useMemo } from 'react';
import dayjs from 'dayjs';
import { chatEmitter } from '../store';

type UserMsgWrapperProps = {
  msg: MessageWithTime<IApiMessageDto>;
};

const BtnBox = ({ children }: PropsWithChildren) => {
  return (
    <div className="size-6 cursor-pointer hover:bg-[#f5f5f5] inline-flex items-center justify-center rounded-[4px]">
      {children}
    </div>
  );
};

export const UserMsgWrapper: React.FC<PropsWithChildren<UserMsgWrapperProps>> = props => {
  const { children, msg } = props;
  const text = useMemo(() => {
    return (msg.subMessage[0] as IApiSubMessageDto).contentValue.text;
  }, [msg]);
  return (
    <div className="group">
      {/* 07:00 Apr 12, 2025 */}
      {msg?.showTime ? (
        <div className="flex justify-center text-[#737373]  text-sm mb-6">
          {dayjs(msg.createTime).format('HH:mm MMM D, YYYY')}
        </div>
      ) : null}
      {children}
      <div className="h-[44px] flex justify-end gap-1 pt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-100 -mb-10">
        <BtnBox>
          <Copy
            size={16}
            color="#525252"
            onClick={() => {
              chatEmitter.emit('copy', text);
            }}
          />
        </BtnBox>
      </div>
    </div>
  );
};
